import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { CheckActionPermission } from "Actions/commonAction";
import CompensatorDashboard from "./CompensatorDashboard";
import ExpenseDashboard from "./ExpenseDashboard";
import { GetFeature } from "../../../../../../Actions/commonAction";
import { FEATUREKEYS } from "../../../../../../Constants";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
class Expense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      showexpense: false,
      showcompensator: false,
    };
    this.setTab = this.setTab.bind(this);
  }

  // componentDidMount() {
  //   const expense = GetFeature("employeeExpense");
  //   const compensator = GetFeature("adminDashboard");
  //   console.log("expense: ", expense);
  //   if (expense && expense.hasAppAccess) {
  //     this.setState({
  //       showexpense: true,
  //     });
  //   } else if (
  //     expense &&
  //     !expense.hasAppAccess &&
  //     compensator &&
  //     compensator.hasAppAccess
  //   ) {
  //     this.props.history.push("/app/pay/expense/compensator");
  //   }
  //   console.log("compensator11: ", compensator);
  //   if (compensator && compensator.hasAppAccess) {
  //     this.setState({
  //       showcompensator: true,
  //     });
  //   }
  //   if (!this.props.location.pathname.includes("compensator")) {
  //     this.setState({
  //       index: 0,
  //     });
  //   } else if (expense.hasAppAccess) {
  //     this.setState({
  //       index: 1,
  //     });
  //   } else {
  //     this.setState({
  //       index: 0,
  //     });
  //   }
  // }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("employeeExpense");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.setState({
          showexpense: true,
          index: 0,
        });
      });
    }
    const [isCompensatorTrue, compermissions] =
      CheckActionPermission("adminDashboard");
    if (isCompensatorTrue) {
      this.setState({ compermissions }, () => {
        const compensator = GetFeature("adminDashboard");
        if (compensator.hasAppAccess) {
          this.setState({
            showcompensator: true,
            index: 1,
          });
        }
      });
    }
  }

  componentWillReceiveProps(props) {
    console.log("props: ", props);
    if (!props.location.pathname.includes("compensator")) {
      this.setState({
        index: 0,
      });
    } else {
      this.setState({
        index: 1,
      });
    }
  }

  setTab(value) {
    this.setState({
      index: value,
    });
  }

  render() {
    const { match, location } = this.props;
    return (
      <div className="width100">
        <div className="common-menubar-header">
          <Tabs
            className="common-menubar-tabs"
            value={this.state.index}
            indicatorColor="primary"
            textColor="primary"
          >
            {this.state.showexpense && (
              <NavLink key={0} to={`/app/pay/expense`}>
                <Tab
                  key={0}
                  label="Expense"
                  className={`tabheading ${
                    this.state.index == 0 ? "active-tab1" : "inactive-tab1"
                  } `}
                  onClick={() => this.setTab(0)}
                />
              </NavLink>
            )}
            {this.state.showcompensator && (
              <NavLink key={1} to={`/app/pay/expense/compensator`}>
                <Tab
                  key={1}
                  label="Compensator"
                  className={`tabheading ${
                    this.state.index == 1 ? "active-tab1" : "inactive-tab1"
                  } `}
                  onClick={() => this.setTab(1)}
                />
              </NavLink>
            )}
          </Tabs>
          {(this.state.showexpense || this.state.showcompensator) && (
            <div className="tab-border" />
          )}
        </div>

        {/* {!location.pathname.includes("compensator")
          ? this.state.showexpense && <ExpenseDashboard {...this.props} />
          : this.state.showcompensator && <CompensatorDashboard {...this.props} />
        } */}

        {location.pathname.includes("compensator") ? (
          <div>
            {this.state.showcompensator ? (
              <CompensatorDashboard {...this.props} {...this.state} />
            ) : (
              <div className="position-rel">
                <PermissionDeniedComp />
              </div>
            )}
          </div>
        ) : (
          <div>
            {this.state.showexpense ? (
              <ExpenseDashboard {...this.props} {...this.state} />
            ) : (
              <div className="position-rel">
                <PermissionDeniedComp />
              </div>
            )}
          </div>
        )}

        {/* {!location.pathname.includes("compensator") &&
        this.state.showexpense ? (
          <ExpenseDashboard {...this.props} />
        ) : (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        )}

        {location.pathname.includes("compensator") &&
        this.state.showcompensator ? (
          <CompensatorDashboard {...this.props} />
        ) : (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        )} */}
      </div>
    );
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(withSnackbar(Expense)),
);
